<template>
  <v-menu v-model="showFilter" :close-on-content-click="false" :eager="true" location="bottom" offset="5"
    transition="fade-transition" :max-width="450">

    <template v-slot:activator="{ props }">
      <v-btn v-bind="props" class="button--primary fab-btn fix">
        <v-icon size="24px">mdi-filter</v-icon>
      </v-btn>
    </template>

    <v-card class="rounded-xl menu-content elevation-12 pa-4">
      <div class="text-h6 font-weight-bold mb-4">Advance Filter</div>

      <v-row>
        <v-col cols="12" class="pa-2">
          <OfferNetworkSelector class="w-100" />
          <OfferSortOptions class="w-100 mt-4" />
        </v-col>

        <v-col cols="12" class="mt-4">
          <div class="text-body-2 font-weight-bold mb-2">Categories</div>
          <div class="d-flex flex-row flex-wrap">
            <OfferCategoryButtons />
          </div>
        </v-col>
      </v-row>
    </v-card>
  </v-menu>
</template>



<script setup>
import { ref } from "vue";
import OfferSortOptions from "@/components/Offer/Offer-Sort-Options.vue";
import OfferNetworkSelector from "@/components/Offer/Offer-Network-Selector.vue";
import OfferCategoryButtons from "@/components/Offer/Offer-Category-Buttons.vue";


const showFilter = ref(false);


</script>



<style scoped lang="scss">

.fix {
  position: fixed;
  bottom: 80px;
  right: 20px;
  z-index: 9;

}

.fab-btn {
  height: 62px !important;
  border: 1px !important;
  width: 65px !important;
  border-radius: 36px;
}

.menu-content {
  background: vars.get-map-value(vars.$backgrounds, tile, secondary) !important;
}
</style>
